/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ms-DetailsListAdvancedExample .ms-CommandBar{margin-bottom:40px}.ms-DetailsListAdvancedExample .ms-DetailsRow-cell .ms-Link{display:block;overflow:hidden;text-overflow:ellipsis;max-width:100%}.ms-DetailsListAdvancedExample .ms-DetailsListAdvancedExample-icon{font-size:16px;width:16px;vertical-align:top;color:"},{"theme":"themePrimary","defaultValue":"#0078d7"},{"rawString":"}"}]);
/* tslint:enable */